module.exports = __webpack_public_path__ + "img/invalid.5050982b.png";